import { useRef } from "react";

import classNames from "shared/utils/classNames";

import StarterQuestionButton from "./StarterQuestionButton";
import { Props } from "./types";

function PopupMessagesIframe(props: Props) {
  const {
    afterMessageQuestions,
    popupClosedByUser,
    onSuggestionClick,
    isOverButton,
  } = props;

  const rootRef = useRef<HTMLDivElement>(null);

  if (popupClosedByUser || isOverButton) {
    return null;
  }

  return (
    <div
      ref={rootRef}
      className={classNames(afterMessageQuestions.length ? "pb-3" : "pb-0")}
    >
      <div
        className={classNames("popup-messages-container", "justify-end")}
        style={{
          flexDirection: "row",
        }}
      >
        {afterMessageQuestions &&
          afterMessageQuestions.map(afterMessageQuestion => (
            <StarterQuestionButton
              key={
                afterMessageQuestion.type === "follow-up-question"
                  ? afterMessageQuestion.question
                  : afterMessageQuestion.id
              }
              afterMessageQuestion={afterMessageQuestion}
              onSuggestionClick={onSuggestionClick}
              isOverButton={isOverButton}
            />
          ))}
      </div>
    </div>
  );
}

export default PopupMessagesIframe;
